// Max file size for image upload components.. Currently set to 10MB
export const MAX_FILE_SIZE = 10000000;

export const fileSizeDisplay = (fileSize: number, decimalPlaces: number = 1) => {
    return fileSize > 1000000 ? `${(fileSize / 1000000).toFixed(decimalPlaces)}MB` : `${(fileSize / 1000).toFixed(0)}K`;
};
